import React, { useState } from 'react';
import { BsChevronDown, BsChevronUp } from 'react-icons/bs'; // Import arrow icons

const FAQSection = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAnswer = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const faqs = [
    {
      question: "How can I find my dream program?",
      answer: "Explore our wide range of options by browsing courses, speaking with our counselors, and assessing your interests and goals to identify the best fit for you.",
    },
    {
      question: "How do I apply once I've found the right program?",
      answer: "Once you’ve selected your program, our team will guide you through the application process step-by-step to ensure a smooth experience.",
    },
    {
      question: "Why should I use Application Uni?",
      answer: "Application Uni simplifies your study abroad journey by offering expert guidance, tailored support, and a seamless application process. Our counselors will guide you in every step and ensure the application is submitted in the best possible manner.",
    },
    {
      question: "Which countries can I apply to study in?",
      answer: "We assist applications to popular study destinations like the USA, UK, Canada, Australia, Europe, and many more.",
    },
    {
      question: "I've applied, so what's next?",
      answer: "After submission, we’ll monitor your application, provide updates, and prepare you for the next steps like visa applications and university admissions.",
    },
    {
      question: "What are the eligibility criteria to apply through Application Uni?",
      answer: "Eligibility depends on the program, university, and country. Our counselors will assess your profile and guide you accordingly.",
    },
    {
      question: "How much does using Application Uni’s services cost?",
      answer: "Our services are free for students. We partner with universities to ensure you have access to opportunities without additional costs.",
    },
    {
      question: "Do you help with scholarships or financial aid?",
      answer: "Yes, we assist you in finding and applying for scholarships and financial aid opportunities in your chosen destination. On average, we have provided 20-25% of tuition fees as a scholarship and in some cases, full 100% scholarships. Scholarships are subjective in nature, at the discretion of the university, and vary significantly. We provide full support to candidates to avail scholarships.",
    },
    {
      question: "How can I track my application status?",
      answer: "Once your application is submitted, we’ll keep you updated regularly and provide you with real-time application insights.",
    },
    {
      question: "Can I apply to multiple universities or courses at the same time?",
      answer: "Yes, we can help you explore multiple options and streamline the application process for several universities and courses. However, before applying for a visa, you need to choose the best of the offers in hand and pay the first installment or other payments as confirmation towards admission to avail necessary documents for applying for a visa.",
    },
    {
      question: "How long does the application process take?",
      answer: "The timeline depends on the university and program, but our team ensures timely submissions and manages deadlines efficiently. However, we can commit to providing you with an offer letter within 10-15 working days. If there are issues with the documentation from the candidate’s end, it may take longer.",
    },
    {
      question: "Will I receive pre-departure guidance?",
      answer: "Yes, we provide comprehensive pre-departure guidance to prepare you for your journey, including visa application support, orientation, and travel advice.",
    },
    {
      question: "What if my visa is rejected?",
      answer: "If your visa is rejected, our team will analyze the reasons, offer guidance, and assist you in reapplying.",
    },
    {
      question: "Refund Policy",
      answer: "Students can make online payments for various services offered by Application Uni through our website and web application. Application Uni assumes no responsibility and shall incur no liability if it is unable to affect any payment instruction(s) on the payment date owing to specific circumstances, including incomplete or delayed payment instructions, insufficient funds, account encumbrances, or issues beyond our control such as natural disasters or system failures. In any other situation, fees collected by Application Uni are non-refundable.",
    },
  ];
  

  const half = Math.ceil(faqs.length / 2);
  const leftColumnFAQs = faqs.slice(0, half);
  const rightColumnFAQs = faqs.slice(half);

  return (
    <div className="container w-full py-16 px-4 lg:px-10">
      <h2 className="text-2xl md:text-2xl lg:text-5xl notoh font-bold text-center mb-12 bg-clip-text text-black ">
        Frequently Asked Questions
      </h2>
      <div className="flex flex-col md:flex-row justify-between mx-auto md:gap-6">
        {/* Left Section */}
        <div className="flex-1 flex flex-col space-y-3 ">
          {leftColumnFAQs.map((faq, index) => (
            <div
            key={index}
            className="rounded-lg shadow-xl overflow-hidden transition-transform duration-300 ease-in-out transform hover:scale-105 hover:shadow-2xl"
          >
            <button
              onClick={() => toggleAnswer(index)}
              className="w-full text-left px-6 py-5 bg-gradient-to-r from-blue-500 to-teal-500 text-white text-lg font-semibold hover:bg-gradient-to-l transition-colors duration-300 flex justify-between items-center"
              style={{ border: 'none' }} // Ensure no border or background underneath
            >
              {faq.question}
              <span
                className={`transition-transform duration-300 ${
                  activeIndex === index ? 'rotate-180' : 'rotate-0'
                }`}
              >
                <BsChevronDown size={20} className="text-white" />
              </span>
            </button>
            {activeIndex === index && (
              <div className="px-6 py-4 bg-gray-50 text-gray-800 text-lg transition-all duration-300 ease-in-out transform opacity-100">
                {faq.answer}
              </div>
            )}
          </div>
          ))}
        </div>

        {/* Right Section */}
        <div
  className="flex-1 flex flex-col space-y-3 lg:pl-4 mt-[20px] lg:mt-0 pl-[0px] pr-[14px] lg:pr-0"
>
  {rightColumnFAQs.map((faq, index) => (
    <div
      key={index + half}
      className="rounded-lg shadow-xl overflow-hidden transition-transform duration-300 ease-in-out transform hover:scale-105 hover:shadow-2xl"
    >
      <button
        onClick={() => toggleAnswer(index + half)}
        className="w-full text-left px-6 py-5 bg-gradient-to-r from-blue-500 to-teal-500 text-white text-lg font-semibold hover:bg-gradient-to-l transition-colors duration-300 flex justify-between items-center"
        style={{ border: 'none' }} // Ensure no border or background underneath
      >
        {faq.question}
        <span
          className={`transition-transform duration-300 ${
            activeIndex === index + half ? 'rotate-180' : 'rotate-0'
          }`}
        >
          <BsChevronDown size={20} className="text-white" />
        </span>
      </button>
      {activeIndex === index + half && (
        <div className="px-6 py-4 bg-gray-50 text-gray-800 text-lg transition-all duration-300 ease-in-out transform opacity-100">
          {faq.answer}
        </div>
      )}
    </div>
  ))}
</div>

      </div>
    </div>
  );
};

export default FAQSection;
